<template>
    <div class="tw:mt-auto tw:flex tw:items-end tw:justify-end tw:gap-2">
        <slot />
    </div>
</template>
<script setup>

</script>